// 唤起直营 sdk的统一出口方法
import { dmEnv, dmBridge } from '@dm/utils';

declare global {
  interface Window {
    globalStore: any;
  }
}

// 必须保证windows全局事件名称不被污染
export const zaAppJSBridgeCallbackNameCreate = (funName) => `ZAJSSDK_${funName.toUpperCase()}_CALLBACK`;

// 设置标题
export const setZaAppWebviewNavigationBarTitle = (title) => {
  const funName = 'setNavigationBarTitle';
  const closeCallbackName = zaAppJSBridgeCallbackNameCreate(funName); // 唤起视频sdk后，关闭当前的webview
  const paramsObj = {
    functionName: funName,
    params: { title },
    complete: closeCallbackName,
  };
  window[closeCallbackName] = (res) => {
    delete window[closeCallbackName];
  };
  window.prompt(JSON.stringify(paramsObj));
};

export const closeZaAppWebView = () => {
  const funName = 'closeWebView';
  const closeCallbackName = zaAppJSBridgeCallbackNameCreate(funName); // 唤起视频sdk后，关闭当前的webview
  const paramsObj = {
    functionName: funName,
    params: {},
    complete: closeCallbackName,
  };
  // 关闭后的回调
  window[closeCallbackName] = (res) => {
    // alert(JSON.stringify({ ...res, msg: 'closeWebView 回调' }));
    delete window[closeCallbackName];
  };

  window.prompt(JSON.stringify(paramsObj));
};

export const CheckZaAudioPermissionConsultation = async () => {
  return new Promise((resolve) => {
    const funName = 'checkPermission';
    const audioPermissionCallbackName = zaAppJSBridgeCallbackNameCreate(funName);
    const audioParamsObj = {
      functionName: funName,
      params: {
        permission: 'RECORD_AUDIO',
      },
      complete: audioPermissionCallbackName,
    };
    // 获取音频权限 0 无权限 1 有权限
    window[audioPermissionCallbackName] = (res) => {
      resolve(res);
      delete window[audioPermissionCallbackName];
    };
    window.prompt(JSON.stringify(audioParamsObj));
  });
};

export const CheckZaVideoPermissionConsultation = async () => {
  return new Promise((resolve) => {
    const funName = 'checkPermission';
    const videoPermissionCallbackName = zaAppJSBridgeCallbackNameCreate(`video${funName}`);
    const videoParamsObj = {
      functionName: funName,
      params: {
        permission: 'CAMERA',
      },
      complete: videoPermissionCallbackName,
    };
    // 获取音频权限 0 无权限 1 有权限
    window[videoPermissionCallbackName] = (res) => {
      resolve(res);
      delete window[videoPermissionCallbackName];
    };
    window.prompt(JSON.stringify(videoParamsObj));
  });
};

export const newCheckZaAudioVideoPermissionConsultation = () => {
  return new Promise(async (resolve) => {
    // 先调相机权限
    const videoRes: any = await CheckZaVideoPermissionConsultation();
    if (videoRes.status === '1') {
      console.log('相机授权回调', '相机:', videoRes.data.result);
      if (videoRes.data.result === '1') {
        // 相机成功后再调麦克风权限
        const audioRes: any = await CheckZaAudioPermissionConsultation();
        if (audioRes.status === '1') {
          console.log('音频授权回调', '音频:', audioRes.data.result);
          if (audioRes.data.result === '1') {
            resolve(true);
          } else {
            console.log('音频授权回调失败', '音频:', audioRes.data.result);
            resolve(false);
          }
        } else {
          console.log('音频授权status不正确', '音频:', audioRes.status);
          resolve(false);
        }
      } else {
        console.log('相机授权回调不正确', '相机:', videoRes.data.result);
        resolve(false);
      }
    } else {
      console.log('相机授权回调status不正确', '相机:', videoRes.status);
      resolve(false);
    }
  });
};

export const getAppSystemInfo = (version = 371) => {
  return new Promise((resolve: (value: boolean) => void) => {
    if (!dmEnv.isApp()) {
      resolve(false);
      return;
    }
    try {
      dmBridge.getSystemInfo().then((res: any) => {
        if (res.status == 1) {
          const { data: { appVersion = '0' } = {} } = res;
          const ver = parseFloat(appVersion.replace(/-|\./g, ''));
          console.log(ver, ver >= version, 'data 版本结果');
          resolve(ver >= version);
          return;
        }
        resolve(false);
        console.log(res, '版本信息结果');
      });
    } catch (error) {
      resolve(false);
      console.log(error, '版本信息出错');
    }
  });
};
